import Vue from "vue";
import Vuex from "vuex";
import { Howl, Howler } from "howler";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    numScenes: 5,
    currentScene: 1,
    beginButton: true,
    muted: false,
    trackTime: 0,
    trackInterval: null,
    audio: {
      scene1: new Howl({
        src: ["audio/producer-scene-1.mp3"],
        html5: true
      }),
      scene2: new Howl({
        src: ["audio/producer-scene-2.mp3"],
        html5: true
      }),
      scene3: new Howl({
        src: ["audio/producer-scene-3.mp3"],
        html5: true
      }),
      scene4: new Howl({
        src: ["audio/producer-scene-4.mp3"],
        html5: true
      }),
      scene5: new Howl({
        src: ["audio/producer-scene-4.mp3"],
        html5: true
      }),
      sampleCountry: new Howl({
        src: ["audio/sample-country.mp3"],
        html5: true
      }),
      samplePop: new Howl({
        src: ["audio/sample-pop.mp3"],
        html5: true
      }),
      sampleTechno: new Howl({
        src: ["audio/sample-techno.mp3"],
        html5: true
      }),
      sampleUrban: new Howl({
        src: ["audio/sample-urban.mp3"],
        html5: true
      }),
      finalCountry: new Howl({
        src: ["audio/final-country.mp3"],
        html5: true
      }),
      finalPop: new Howl({
        src: ["audio/final-pop.mp3"],
        html5: true
      }),
      finalTechno: new Howl({
        src: ["audio/final-techno.mp3"],
        html5: true
      }),
      finalUrban: new Howl({
        src: ["audio/final-urban.mp3"],
        html5: true
      }),
    }
  },
  mutations: {
    SET_CURRENT_SCENE(state, payload) {
      state.currentScene = payload;
    },
    PREVIOUS_SCENE(state) {
      state.currentScene--;
    },
    NEXT_SCENE(state) {
      state.currentScene++;
    },
    HIDE_BEGIN_BUTTON(state) {
      state.beginButton = false;
    },
    MUTE(state) {
      state.muted = true;
    },
    UNMUTE(state) {
      state.muted = false;
    },
    RESET_TRACK_TIME(state) {
      state.trackTime = 0;
    },
    RESET_TRACK_INTERVAL(state) {
      clearInterval(state.trackInterval);
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.5;
      }, 500);
    },
    CLEAR_TRACK_INTERVAL(state) {
      clearInterval(state.trackInterval);
    }
  },
  actions: {
    begin({ state, commit }) {
      commit("HIDE_BEGIN_BUTTON");
      state.audio.scene1.play();
      commit("RESET_TRACK_INTERVAL");
      commit("RESET_TRACK_TIME");
    },
    previousScene({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit("PREVIOUS_SCENE");
      }
      dispatch("playAudioByScene");
      if (state.audio[name].playing()) {
        state.audio[name].stop();
      }
    },
    rewindScene({ state, commit,dispatch }) {
      if (state.currentScene > 1) {
        commit("PREVIOUS_SCENE");
      }
      dispatch("playAudioByScene");

    },
    nextScene({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit("NEXT_SCENE");
      } else {
        if (window.history.length > 1) {
          window.history.go(-1);
        } else {
          commit("SET_CURRENT_SCENE", 1);
        }
      }
      dispatch("playAudioByScene");
    },
    toggleMute({ state, commit }) {
      if (state.muted) {
        Howler.mute(false);
        commit("UNMUTE");
      } else {
        Howler.mute(true);
        commit("MUTE");
      }
    },
    stopAllAudio({ state, commit }) {
      Object.keys(state.audio).forEach(key => {
        state.audio[key].stop();
      });
      commit("CLEAR_TRACK_INTERVAL");
      commit("RESET_TRACK_TIME");
    },
    playAudioByScene({ state, commit, dispatch }) {
      dispatch("stopAllAudio");
      if (typeof state.audio[`scene${state.currentScene}`] !== "undefined") {
        state.audio[`scene${state.currentScene}`].play();
        commit("RESET_TRACK_INTERVAL");
        commit("RESET_TRACK_TIME");
      }
    },
    toggleAudioByName({ state  }, name) {
      if (typeof state.audio[name] !== "undefined") {
        if (state.audio[name].playing()) {
          state.audio[name].stop();
        } else {
          Object.keys(state.audio).forEach(key => {
            state.audio[key].stop();
          });
          state.audio[name].play();
        }
      }
    }
  }
});

export default store;
